import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import SectoralStockIndicesFull from './sectoral-stock-indices-full';

const SectoralStockIndicesFullWidget = (props) => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <SectoralStockIndicesFull {...props} />
    </QueryClientProvider>
  );
};

export { SectoralStockIndicesFullWidget }
